import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { $$ } from '@/lib/utils';

$$('.gallery').forEach((gallery) => {
  const lightbox = new PhotoSwipeLightbox({ gallery, children: 'a', pswpModule: PhotoSwipe });
  lightbox.init();
});
